import { Brain } from 'lucide-react';

export const GAME_INFO: GameInfo = {
  id: 2,
  title: 'Memòria',
  description: '',
  instructions: [
    'Clica les cartes per descobrir parelles i avançar.',
    'Necessites entre 10 i 25 intents per completar la ronda.',
    'El minijoc acaba si et quedes sense intents. Clica amb astúcia!',
    'Cada parella descoberta et porta més a prop de la victòria.',
  ],
  icon: Brain,
  path: '/memoria',
  category: 'Puzles',
  localStorageKey: 'memoryGameStats',
  customStatLabel: 'Parelles Resoltes',
  customStatLabelSingular: 'Parelles Resoltes',
  defaultGameMode: 'pairs6',
  gameModeTitle: 'Selecciona les Parelles',
  gameModes: [
    {
      id: 'pairs4',
      name: '4 Parelles',
    },
    {
      id: 'pairs6',
      name: '6 Parelles',
    },
    {
      id: 'pairs8',
      name: '8 Parelles',
    },
    {
      id: 'pairs10',
      name: '10 Parelles',
    },
  ],
};
